import {DefaultSchema} from '@/schema/DefaultSchema'
import {FieldComponent, FieldSet} from '@simpli/meta-schema'
import * as Component from '@simpli/vue-render-schema'
import {GithubOrganization} from '@/model/resource/GithubOrganization'
import RenderColor from '@/components/render/RenderColor.vue'
import {$} from '@/facade'

export class ListGithubOrganizationSchema extends DefaultSchema {
  readonly name = 'ListGithubOrganization'

  readonly fieldSet: FieldSet<GithubOrganization> = {
    name: (): FieldComponent => ({
      is: Component.Render,
    }),
    colorHex: (): FieldComponent => ({
      is: RenderColor,
    }),
    logoUrl: (schema): FieldComponent => ({
      is: Component.RenderImage,
      bind: {
        src: schema.model.logoUrl,
        alt: this.translateFrom(schema.fieldName),
        innerClass: 'w-20 h-20',
      },
    }),
    url: (): FieldComponent => ({
      is: Component.Render,
    }),
    location: (): FieldComponent => ({
      is: Component.Render,
    }),
    establishedYear: (): FieldComponent => ({
      is: Component.Render,
    }),
    active: (): FieldComponent => ({
      is: Component.Render,
    }),
    createdAt: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: $.filter.datetime(schema.model.createdAt),
      },
    }),
    updatedAt: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: $.filter.datetime(schema.model.updatedAt),
      },
    }),
  }
}
